import { CategoryDto, CategoryTreeNode } from "types/notice/CategoryDto";

 

export const buildCategoryTree = (categories: CategoryDto[]): CategoryTreeNode[] => {
  const map = new Map<string, CategoryTreeNode & { parentId: string | null }>();
  const roots: CategoryTreeNode[] = [];

  // ۱. ساخت تمام نودها
  categories.forEach((cat) => {
    map.set(cat.Id, {
      value: cat.Id,
      title: cat.LocalizedName,
      selectable: cat.LastNode, // فقط نودهای آخر قابل انتخاب هستند
      parentId: cat.ParentCategoryId,
    });
  });

  // ۲. اتصال فرزندان به والدین
  map.forEach((node) => {
    if (node.parentId && map.has(node.parentId)) {
      const parent = map.get(node.parentId);
      if (parent) {
        parent.children = parent.children || [];
        parent.children.push(node);
      }
    } else {
      roots.push(node); // نودهای ریشه (بدون والد)
    }
  });

  return roots;
};
